module.exports = __webpack_public_path__ + "img/max-file-search--json.c3a22e68.svg";